const DocumentsSVGOld = ({ className, parentClassName }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      d="M24 12L18 6H10C9.46957 6 8.96086 6.21071 8.58579 6.58579C8.21071 6.96086 8 7.46957 8 8V24C8 24.5304 8.21071 25.0391 8.58579 25.4142C8.96086 25.7893 9.46957 26 10 26H22C22.5304 26 23.0391 25.7893 23.4142 25.4142C23.7893 25.0391 24 24.5304 24 24V12ZM18 13H17V8L22 13H18Z"
      fill="none"
      className={className}
    />
  </svg>
);

const DocumentsSVG = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.8573 8.63867H19.8995C20.2473 8.63867 20.5808 8.77679 20.8264 9.02274C21.0723 9.2684 21.2105 9.60184 21.2105 9.94961V18.6891C21.2105 19.037 21.0723 19.3704 20.8264 19.616C20.5807 19.8621 20.2473 20 19.8995 20H4.16824C3.82046 20 3.487 19.8621 3.24137 19.616C2.99542 19.3705 2.8573 19.037 2.8573 18.6891V8.63867Z"
      fill="none"
      className={className}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3957 6.01679C12.3314 5.8342 12.2265 5.66638 12.0866 5.52695C11.8411 5.28086 11.5077 5.14288 11.1599 5.14288H4.16812C3.82034 5.14288 3.48688 5.28085 3.24125 5.52695C2.9953 5.77246 2.85718 6.1059 2.85718 6.45382V7.76476H3.73109V7.32773C3.73109 6.60365 4.31794 6.01679 5.04203 6.01679H12.3957Z"
      fill="none"
      className={className}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.4624 7.76481H4.60535V7.32778C4.60535 7.08651 4.80111 6.89075 5.04223 6.89075H19.0258C19.267 6.89075 19.4627 7.08651 19.4627 7.32778L19.4624 7.76481Z"
      fill="none"
      className={className}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.8573 8.63867H19.8995C20.2473 8.63867 20.5808 8.77679 20.8264 9.02274C21.0723 9.2684 21.2105 9.60184 21.2105 9.94961V18.6891C21.2105 19.037 21.0723 19.3704 20.8264 19.616C20.5807 19.8621 20.2473 20 19.8995 20H4.16824C3.82046 20 3.487 19.8621 3.24137 19.616C2.99542 19.3705 2.8573 19.037 2.8573 18.6891V8.63867Z"
      fill="none"
      className={className}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3957 6.01679C12.3314 5.8342 12.2265 5.66638 12.0866 5.52695C11.8411 5.28086 11.5077 5.14288 11.1599 5.14288H4.16812C3.82034 5.14288 3.48688 5.28085 3.24125 5.52695C2.9953 5.77246 2.85718 6.1059 2.85718 6.45382V7.76476H3.73109V7.32773C3.73109 6.60365 4.31794 6.01679 5.04203 6.01679H12.3957Z"
      fill="none"
      className={className}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.4624 7.76481H4.60535V7.32778C4.60535 7.08651 4.80111 6.89075 5.04223 6.89075H19.0258C19.267 6.89075 19.4627 7.08651 19.4627 7.32778L19.4624 7.76481Z"
      fill="none"
      className={className}
    />
  </svg>
);

export { DocumentsSVG };
